export const purchaseProductTypes = [
  { id: 1, name: 'สินค้า' },
  { id: 2, name: 'บริการ' },
  { id: 3, name: 'สินค้าภายใน' },
  { id: 4, name: 'สินค้าประกอบ' },
  { id: 5, name: 'ทรัพย์สิน' },
]
